import {
    BesvarteSporsmalStateDTO,
    BygningObjektWebDTO,
    ForsikringDekningDTO,
    ForsikringPeriodeWebDTO,
    Forsikringsprodukt,
} from './generated-types';

export type Kundeinfo = {
    epost: string;
    etternavn: string;
    offentligId: string;
    fornavn: string;
    forsikringer: ForsikringUnion[];
    kundenummer: string;
    mobilnummer: string;
};

export type ForsikringUnion =
    | Motorforsikring
    | Reiseforsikring
    | Elsparkesykkelforsikring
    | Personforsikring
    | AnnenForsikring;

export type ForsikringPeriode = ForsikringPeriodeWebDTO;
export type ForsikringDekning = ForsikringDekningDTO;

export interface Forsikring {
    forsikringsnummer: string;
    forsikringstekst?: string;
    info?: string;
    periode?: ForsikringPeriode;
    produkt: Forsikringsprodukt;
    type:
        | 'Motorforsikring'
        | 'Reiseforsikring'
        | 'Elsparkesykkelforsikring'
        | 'Bygningforsikring'
        | 'Personforsikring'
        | 'AnnenForsikring';
    versjon: number;
    visningstekst: string;
}

export interface Motorforsikring extends Forsikring {
    dekning: ForsikringDekning;
    registreringsar: number;
    type: 'Motorforsikring';
}

export interface Elsparkesykkelforsikring extends Forsikring {
    dekning: ForsikringDekning;
    type: 'Elsparkesykkelforsikring';
}

export interface Personforsikring extends Forsikring {
    dekning: ForsikringDekning;
    type: 'Personforsikring';
}

export interface Reiseforsikring extends Forsikring {
    dekning: ForsikringDekning;
    type: 'Reiseforsikring';
}

export type BygningObjekt = BygningObjektWebDTO;

export interface Bygningforsikring extends Forsikring {
    dekning: ForsikringDekning;
    objekter: BygningObjekt[];
    type: 'Bygningforsikring';
}

export interface AnnenForsikring extends Forsikring {
    dekning: ForsikringDekning;
    type: 'AnnenForsikring';
}

export type BesvarteSporsmalFromCache = BesvarteSporsmalStateDTO;

export enum SkademeldingError {
    vedleggError = 'KLARTE_IKKE_LESE_VEDLEGG',
}

export interface ForsikringOppsummeringInformation {
    bonus?: Bonus;
    egenandel?: Egenandel;
    kjorelengde?: MaksKjorelengde;
}

export interface Bonus {
    tittel: string;
    innhold: string;
    displayStatus: DisplayStatus;
}

export interface Egenandel {
    tittel: string;
    innhold: string;
    displayStatus: DisplayStatus;
}

export interface MaksKjorelengde {
    tittel: string;
    innhold: string;
    displayStatus: DisplayStatus;
}

export enum DisplayStatus {
    Show = 'Show',
    Hide = 'Hide',
}
